import { extractFirstWordFromUrl } from "@/frontend/shared/lib/extractFirstWordFromUrl/extractFirstWordFromUrl";
import { GearSixIcon, UserIcon } from "../../../shared/assets/icons";
import { LogoSvg } from "@/frontend/shared/assets/LogoSvg";
import { SquareButton } from "@/frontend/shared/ui/Button";
import { Typography } from "@/frontend/shared/ui/Typography/Typography";
import styles from "./InnoveraHeader.module.scss";
import { UsersAvatar } from "@/frontend/shared/ui/UsersAvatar/UsersAvatar";
import clsx from "clsx";
import {
  getRouteCompanies,
  getRouteDashboard,
  getRouteSettingsPage,
  getRouteSignIn
} from "@/frontend/shared/const/router";
import { useHistoricalNavigate } from "@/frontend/shared/lib/useHistoricalNavigate/useHistoricalNavigate";
import { DropshadowMenu } from "@/frontend/shared/ui/DropshadowMenu";
import { useState } from "react";
import { postLogout } from "../model/services/postLogout";
import { useLocation } from "react-router-dom";
import { useMe } from "@/frontend/shared/lib/hooks/useMe";

type THeaderType = "default" | "settings" | "privacyAndTerms";

export function InnoveraHeader({ className, type = "default" }: { className?: string; type?: THeaderType }) {
  const { pathname } = useLocation();
  const currentDirectory = pathname.split("/")[1];
  const { navigate, stepBack } = useHistoricalNavigate();
  const [isHeaderMenuOpen, setIsHeaderMenuOpen] = useState(false);

  const { derived, data: profileData } = useMe();

  async function logout() {
    await postLogout();
    localStorage.clear();
    navigate(getRouteSignIn());
  }

  function getPageName() {
    switch (currentDirectory) {
      case "terms-of-use":
        return "Terms of Use";
      case "privacy-notice":
        return "Privacy Notice";
      default:
        return null;
    }
  }

  switch (type) {
    case "settings":
      return (
        <div className={clsx(styles.settingsContainer, className)}>
          <LogoSvg className={styles.logoSvg} onClick={() => navigate(getRouteDashboard())} />
          <Typography className={styles.buttonsContainer} variant="label-4" color="greyscale700">
            Settings
          </Typography>
          <div>
            <div className={styles.rightSideContainer}>
              {/* <div className={styles.dividerLine} /> */}
              <div className={styles.iconsContainer}>
                {/* <SquareButton size="medium" variant="tertiary">
                  <NotificationIcon />
                </SquareButton> */}
                <SquareButton size="medium" variant="tertiary" onClick={() => navigate(getRouteSettingsPage())}>
                  <GearSixIcon />
                </SquareButton>
              </div>
              <div className={styles.avatarContainer}>
                <UsersAvatar
                  nameInitials={derived.nameInitials}
                  className={styles.avatar}
                  profileImg={derived.profileImageUrl}
                  organizationId={profileData?.organizationId}
                  onClick={() => {
                    setIsHeaderMenuOpen((prev) => !prev);
                  }}
                />
                <DropshadowMenu
                  isOpen={isHeaderMenuOpen}
                  onClose={() => setIsHeaderMenuOpen(false)}
                  options={[
                    <div className={styles.dropshadowOption} onClick={logout}>
                      <UserIcon /> Logout
                    </div>
                  ]}
                  top="30px"
                  right="0px"
                />
              </div>
            </div>
          </div>
        </div>
      );
    case "privacyAndTerms":
      return (
        <div className={clsx(styles.settingsContainer, className)}>
          <LogoSvg className={styles.logoSvg} onClick={stepBack} />
          <Typography className={styles.buttonsContainer} variant="label-4" color="greyscale700">
            {getPageName()}
          </Typography>
        </div>
      );
    case "default":
      return (
        <div className={clsx(styles.container, className)}>
          <LogoSvg className={styles.logoSvg} />
          <div className={styles.buttonsContainer}>
            <div
              className={clsx(styles.switchPageButtonExternal, currentDirectory === "dashboard" && styles.active)}
              onClick={() => navigate(getRouteDashboard())}
            >
              <Typography variant="label-4" color="greyscale900" className={clsx(styles.switchPageButton)}>
                Dashboard
              </Typography>
            </div>
            <div
              className={clsx(styles.switchPageButtonExternal, currentDirectory === "companies" && styles.active)}
              onClick={() => navigate(getRouteCompanies())}
            >
              <Typography variant="label-4" color="greyscale900" className={clsx(styles.switchPageButton)}>
                Companies
              </Typography>
            </div>
          </div>{" "}
          <div>
            <div className={styles.rightSideContainer}>
              {/* <div className={styles.marketResearchBtn}>
                <MarketResearchIcon2 className={styles.marketResearchIcon} />
                <Typography variant="label-4" color="greyscale900" className={styles.marketResearchText}>
                  Market research
                </Typography>
              </div> */}
              {/* <div className={styles.dividerLine} /> */}
              <div className={styles.iconsContainer}>
                {/* <SquareButton size="medium" variant="tertiary">
                  <NotificationIcon />
                </SquareButton> */}
                <SquareButton size="medium" variant="tertiary" onClick={() => navigate(getRouteSettingsPage())}>
                  <GearSixIcon />
                </SquareButton>
              </div>
              <div className={styles.avatarContainer}>
                <UsersAvatar
                  className={styles.avatar}
                  nameInitials={derived.nameInitials}
                  profileImg={derived.profileImageUrl}
                  organizationId={profileData?.organizationId}
                  onClick={() => {
                    setIsHeaderMenuOpen((prev) => !prev);
                  }}
                />
                <DropshadowMenu
                  isOpen={isHeaderMenuOpen}
                  onClose={() => setIsHeaderMenuOpen(false)}
                  options={[
                    <div
                      className={styles.dropshadowOption}
                      onClick={() => {
                        logout();
                      }}
                    >
                      <UserIcon /> Logout
                    </div>
                  ]}
                  top="30px"
                  right="0px"
                />
              </div>
            </div>
          </div>
        </div>
      );
    default:
      null;
  }
}
